// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3aXMi","bigColWidth":"Table_bigColWidth__1k7bF","biggerColWidth":"Table_biggerColWidth__38ybL","row":"Table_row__2tdyX","col":"Table_col__tNHMo"};